import { render, staticRenderFns } from "./stripe-connect-link.vue?vue&type=template&id=4d1a7b2f&scoped=true&"
import script from "./stripe-connect-link.ts?vue&type=script&lang=ts&"
export * from "./stripe-connect-link.ts?vue&type=script&lang=ts&"
import style0 from "./stripe-connect-link.scss?vue&type=style&index=0&id=4d1a7b2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1a7b2f",
  null
  
)

export default component.exports